export default __webpack_public_path__ + "static/rovo-elevation-light-abb697fbec2d8ee25ac74e3e35c32ce2.png";